<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="ion-text-center header-title">{{ 'FOR_PROVIDERS.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start" class="header-buttons" style="margin-left:5px">
        <ion-back-button  color="secondary" defaultHref="/" text=""></ion-back-button>
        <!--ion-button [routerLink]="['/']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button-->
      </ion-buttons>

       <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<ion-content>

  <ion-grid fixed class="ion-padding">
    <ion-row>
      <ion-col class="info">

        <h1 class="info__title">{{ 'FOR_PROVIDERS.QUESTION_10' | translate }}</h1>

        <p class="info__content">{{ 'FOR_PROVIDERS.PARAGRAPH_10' | translate }}</p>

        <p class="info__content">{{ 'FOR_PROVIDERS.PARAGRAPH_20' | translate }}</p>

        <p class="info__content">{{ 'FOR_PROVIDERS.PARAGRAPH_30' | translate }}</p>

        <p class="info__content">{{ 'FOR_PROVIDERS.SEND_EMAIL' | translate }} <a href="mailto:stik@table42.app">stik@table42.app</a> {{ 'FOR_PROVIDERS.OR_CALL_US' | translate }} <a href="tel:+38631312038"><span *ngIf="translateService.currentLang == 'sl'">0</span><span *ngIf="translateService.currentLang !== 'sl'">+386 </span>31 312 038</a>.</p>

        <span *ngIf="translateService.currentLang == 'sl'">

        <h2 class="info__content" style="font-weight: bold">{{ 'FOR_PROVIDERS.ATTRACT' | translate }}</h2>

        <p class="info__content">{{ 'FOR_PROVIDERS.MORE_INFO_AT' | translate }} <a href="https://table42.app">www.table42.app</a></p>
        </span>

        <!--p class="info__content">Če vaša restavracija ustreza standardom za objavo, boste objavljeni v roku 48h. V nasprotnem primeru boste prejeli ustrezna navodila, kaj morate še urediti, da se pridružite najboljšim restavracijam v Sloveniji.</p-->

      </ion-col>

    </ion-row>
  </ion-grid>
 
</ion-content>